import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { JobSearchService } from '../../../../../UI/src/app/shared/job-search/job-search.service';
import { AuthenticationService } from '../../../../../UI/src/app/shared/authentication/authentication.service';
import { JobAlertService } from '../../../../../UI/src/app/shared/job-alert/job-alert.service';
import { ToastControllerService } from '../../../providers/toast-controller.service'
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from '../../../../../UI/src/app/shared/profile/profile.service';
import { HomeComponent } from '../home/home.component'
import { AlertController } from 'ionic-angular';
import { Jobsfilter, MultiSelect } from '../../../../../UI/src/app/shared/job-search/job-results.dto';
import * as _ from 'lodash';
import { ResumeService } from '../../../../../UI/src/app/shared/resume/resume.service';
@Component({
  selector: 'page-job-alert',
  templateUrl: 'job-alert.component.html'
})
export class JobAlertComponent {
  areFiltersAvailable = false;
  data = {
     defaultKeyWords: '', deleted: false, searchText:''
    };
  filters = [];
  isloggedin = this.authService.isUserLoggedin();
  private jobAlertForm: FormGroup;
  private alertData = null;
  showMobileError = false;
  showEmailError = false;
  saveDisabled = false;
  isEdit = false;
  isMobileNumberValid = true;
  isMobileAvilable = false;
  isEmailAvilable = false;
  profileData = { mobile: '', email1: '' };
  candidateTranslations: any;
  catcode = 0;
  locationsInfo: any[] = [];
  locations: MultiSelect[] = [];
  selectedLocations: any[] = [];
  selectedCategories: any[] = [];
  selectedJobTypes: any[] = [];
  locationsInputId: String;
  categoriesInputId: String;
  jobTypeInputId: String;
  jobTypeList: any[] = [];
  jobTypes: MultiSelect[] = [];
  categoryList: any[] = [];
  categories: MultiSelect[] = [];
  locationsPlaceholder: String;
  categoriesPlaceholder: String;
  jobTypePlaceholder: String;
  skillsInputId : String;
  skillsPlaceholder : String;
  skillsList : any[]=[];
  allowUserInput : boolean=true;
  public alive = true;
  public skillsArray = [];
  selectedSkills: any[] = [];
  private jobFilters: Jobsfilter[] = [];

  constructor(
    private formBuilder: FormBuilder,
    public jobSearchService: JobSearchService,
    public AlertController: AlertController,
    public navCtrl: NavController,
    private authService: AuthenticationService,
    private jobAlertService: JobAlertService,
    private toastService: ToastControllerService,
    private translate: TranslateService,
    private profileService: ProfileService,
    private navParams: NavParams,
    private resumeService : ResumeService,
  ) {
   
    this.translate.get(['CAREER_JOB_ALERT_CREATED',
      'CAREER_ALERT_UPDATE_MESSAGE',
      'CAREER_ALERT_DELETE_MESSAGE',
      'CAREER_JOBALERT_DELETE_CONFIRMATION',
      'CAREER_CANCEL', 'CAREER_OK' ,'CAREER_JOB_TYPE_JOB_ALERT',
      'CAREER_CATEGORY_JOB_ALERT', 'CAREER_LOCATIONS_JOB_ALERT',
      'CAREER_KEYWORDS_JOB_ALERT'
    ]).subscribe((obj) => {
      this.candidateTranslations = obj;
    });
    if (!this.isloggedin)
      this.jobAlertForm = this.formBuilder.group({
        alertName: ['', Validators.required], 
        keywords:[''],       
        profileMatchInd: [''],
        filtersAvailable: ['']
      });
    else
      this.jobAlertForm = this.formBuilder.group({
        alertName: ['', Validators.required],   
        keywords:[''],  
        profileMatchInd: [''],
        filtersAvailable: ['']
      });
    // check if navigation params has JobAlert Data Object 
    if (Object.keys(navParams.data).length !== 0) {
      this.data = navParams.data;
      this.isEdit = true;
      if (typeof this.data.defaultKeyWords !== 'undefined' && this.data.defaultKeyWords) {
        this.filters = JSON.parse(this.data.defaultKeyWords);
        for (let i = 0; i < this.filters.length; i++) {
          if (!this.filters[i].removed) {
            this.filters[i].removed = false;
          }
        }
      }
      this.areFiltersAvailable = this.filters.length > 0 ? true : false;
    }
  }

  createAlert() {
    
    
    this.updateDataInFilterObject(this.selectedJobTypes, 'JobType');
    this.updateDataInFilterObject(this.selectedCategories, 'Category');
    this.updateDataInFilterObject(this.selectedLocations, 'City');
    if (this.jobFilters && this.jobFilters.length > 0) {
      this.data.defaultKeyWords = JSON.stringify(this.jobFilters);
    }
    else{
      
        this.data.defaultKeyWords = '';
      
    }
    if(this.selectedSkills && this.selectedSkills.length >0){
      this.data.searchText='';
      this.selectedSkills.forEach(skill => {
        this.data.searchText = this.data.searchText + skill.name +",";
      });
      this.data.searchText=this.data.searchText.slice(0,-1);
    }
    else{
      this.data.searchText='';
    }
    this.jobAlertService.saveJobAlert(this.data, this.isloggedin).then(
      res => {
        if (res === true) {
              if (!this.isEdit) {
           
                this.alertData = { message: this.candidateTranslations['CAREER_JOB_ALERT_CREATED'], type: 'success' }
                this.toastService.presentToast(this.alertData);
           
          }
          else {
           
                this.alertData = { message: this.candidateTranslations['CAREER_ALERT_UPDATE_MESSAGE'], type: 'success' }
                this.toastService.presentToast(this.alertData);
             
          }
          this.navCtrl.pop();
        }
      });
    
    
     
  }

  onCancel() {
    if (this.navCtrl.length() > 1) {
    this.navCtrl.pop();
  }
    else {
      this.navCtrl.setRoot(HomeComponent);
    }
  }

  selectedItemChanged() {
    this.showMobileError = false;
    this.showEmailError = false;
    if (this.isloggedin) {
      this.isMobileNumberValid = false;
    }
    
    this.saveDisabled = this.showEmailError || this.showMobileError;
  }

  deleteJobAlert() {
    this.data.deleted = true;
    this.jobAlertService.saveJobAlert(this.data, true).then(
      res => {
        if (res === true) {
          this.alertData = { message: this.candidateTranslations.CAREER_ALERT_DELETE_MESSAGE, type: 'success' };
          this.toastService.presentToast(this.alertData);
          this.navCtrl.pop();
          // this.getJobAlerts();
        }
      });
  }

  showDeleteConfirm() {
    let confirm = this.AlertController.create({
      message: this.candidateTranslations.CAREER_JOBALERT_DELETE_CONFIRMATION,
      buttons: [
        {
          text: this.candidateTranslations.CAREER_CANCEL,
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: this.candidateTranslations.CAREER_OK,
          handler: (jobAlert) => {
            this.deleteJobAlert();
          }
        }
      ]
    });
    confirm.present();
  }

  ngOnInit() {
    if (this.isloggedin) {
      if (!this.isEdit) {
        this.filters = this.jobSearchService.getJobFilters();
        this.filters.forEach(el => el.applied = true);
        if (this.filters != null) {
          this.areFiltersAvailable = this.filters.length > 0 ? true : false;
        }
      }
      if (this.jobSearchService.findSearchText()!== undefined && this.jobSearchService.findSearchText().length > 1) {

        this.data.searchText = this.jobSearchService.findSearchText().toString();
      }
      this.profileService.getProfileData().subscribe(
        (response) => {
          this.profileData = response[0];
          if (this.profileData) {
            if (this.profileData.mobile) {
              this.isMobileAvilable = true;
            }
            if (this.profileData.email1) {
              this.isEmailAvilable = true;
            }
          }
          if (this.isEdit)
            this.selectedItemChanged();
        });
        this.BindSelectedItems();
        if(this.data.searchText){
          this.data.searchText.split(',').forEach(skill => {
            this.selectedSkills.push({'Id' : skill , 'name' : skill });
          })
        }
        this.jobSearchService.fetchLocations().then((res) => {

          this.locationsInfo = _.map(res, (item) => {
            if (item.customField1 !== 'Country') {
              return item.key;
            }
          });
          
          this.locations = [];
  
          if (this.locationsInfo && this.locationsInfo.length > 0) {
            this.locationsInfo.forEach(loc => {
              if (loc) {
                this.locations.push({ 'Id': loc, 'name': loc })
              }
            });
            this.locationsInputId = 'Locations'
            this.locationsPlaceholder = this.candidateTranslations['CAREER_LOCATIONS_JOB_ALERT'];
          }
  
        });
        this.catcode = 41008// category
        this.jobSearchService.getDataByCategoryCode(this.catcode).then((res) => {
          this.categoryList = _.sortBy(res, (item) => { return (item) });
          this.categories = [];
          this.categoryList.forEach(cat => {
            if (cat) {
              this.categories.push({ 'Id': cat.itemText, 'name': cat.itemText })
            }
          });
          this.categoriesInputId = 'categories'
          this.categoriesPlaceholder = this.candidateTranslations['CAREER_CATEGORY_JOB_ALERT'];
        })
  
        this.catcode = 41007// Employment Type
        this.jobSearchService.getDataByCategoryCode(this.catcode).then((res) => {
  
          this.jobTypeList = _.sortBy(res, (item) => { return (item) });
          this.jobTypes = [];
          this.jobTypeList.forEach(job => {
            if (job) {
              this.jobTypes.push({ 'Id': job.itemText, 'name': job.itemText })
            }
          });
          this.jobTypeInputId = 'jobTypes';
          this.jobTypePlaceholder = this.candidateTranslations['CAREER_JOB_TYPE_JOB_ALERT'];
        });

        let skills=this.resumeService.getSkillsList(1,-1,'');
        skills.takeWhile(() => this.alive)
        .subscribe((obj: any) => {
           
            this.skillsArray = obj.lookups;
            if (this.skillsArray && this.skillsArray.length>0) {
              this.skillsArray.forEach(skill => {
                if (skill) {
              this.skillsList.push({'Id': skill.value, 'name': skill.value })
                }
              });
              this.skillsInputId='skills';
              this.skillsPlaceholder=this.candidateTranslations['CAREER_KEYWORDS_JOB_ALERT']
            }        
        }, err => {       
        });
        
  
      }
    }
  
  MultiSelectedItemsJobType(Selectedjobtypes: MultiSelect[]) {
    this.selectedJobTypes = Selectedjobtypes;

  }

  MultiSelectedItemsLocation(selectedlocations: MultiSelect[]) {
    this.selectedLocations = selectedlocations;

  }

  MultiSelectedItemsCategory(Selectedcategories: MultiSelect[]) {
    this.selectedCategories = Selectedcategories;

  }
  MultiSelectedItemsSkill(eventData: MultiSelect[]){
    this.selectedSkills=eventData;
  }


  onfocusout(event: any) {

  }
  onkeypress(event: any) {

  }
  public updateDataInFilterObject(items: any, fieldName: string) {

    const filter: Jobsfilter = new Jobsfilter;
    items.forEach(element => {
      filter.name = fieldName;
      filter.searchFieldName = fieldName;

      filter.value = encodeURIComponent(element.name.toString());
      filter.uncodedValue = element.name.toString();
      this.jobFilters.push({ ...filter });

    });
  }
  private BindSelectedItems() {


    this.filters.forEach(item => {
      if (item.searchFieldName === 'JobType') {
        this.selectedJobTypes.push({ 'Id': item.uncodedValue, 'name': item.uncodedValue })

      }
      if (item.searchFieldName == 'City') {
        this.selectedLocations.push({ 'Id': item.uncodedValue, 'name': item.uncodedValue })
      }
      if (item.searchFieldName == 'Category') {
        this.selectedCategories.push({ 'Id': item.uncodedValue, 'name': item.uncodedValue })
      }

    })

  }
}


// WEBPACK FOOTER //
// ./src/app/modules/job-alert/job-alert.component.ts